import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureUpgradeCardProps {
  featureName: string;
  description?: string;
}

export const FeatureUpgradeCard = ({ featureName, description }: FeatureUpgradeCardProps) => {
  return (
    <Card className="border-dashed">
      <CardHeader className="text-center pb-2">
        <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-2">
          <Lock className="h-6 w-6 text-muted-foreground" />
        </div>
        <CardTitle className="text-lg">{featureName}</CardTitle>
        <CardDescription>
          {description || "This feature is available on Pro plan and above."}
        </CardDescription>
      </CardHeader>
      <CardContent className="text-center">
        <p className="text-sm text-muted-foreground mb-4">
          Upgrade to Pro to unlock {featureName} and get more out of your extractions.
        </p>
        <Button asChild>
          <Link to="/plans">Upgrade to Pro</Link>
        </Button>
      </CardContent>
    </Card>
  );
};
